import { Text } from '@lmc/ui-kit/src/general'
import { capitalize } from 'lodash'
import EventIcon from 'screens/Rostering/RotaBuilder/common/components/EventIcon'
import styled from 'styled-components'
import { RotaInstanceStatus } from 'screens/Rostering/types'

type EventCountProps = {
  type: string
  count: number
  fixedWidth?: boolean
}

export function getRotaInstanceStatus(status: string): RotaInstanceStatus {
  const normalizedStatus = status
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toUpperCase()
    .replace(' ', '_')

  return RotaInstanceStatus[normalizedStatus as keyof typeof RotaInstanceStatus]
}

const EventCount = ({ type, count, fixedWidth = false }: EventCountProps) => {
  const status = getRotaInstanceStatus(type)

  return (
    <Container fixedWidth={fixedWidth}>
      <EventTypeContainer>
        <EventIcon status={status} />
        <Text>{capitalize(status)}</Text>
      </EventTypeContainer>
      <Text>{count}</Text>
    </Container>
  )
}

const Container = styled.div<{ fixedWidth: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ fixedWidth }) =>
    fixedWidth ? 'unset' : 'space-between'};
  gap: ${({ fixedWidth }) => (fixedWidth ? '24px' : '0')};
  width: 100%;
`

const EventTypeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export default EventCount
